import { ChangeDetectionStrategy, Component, computed, input } from '@angular/core';
import {
  AlertTriangle,
  CheckCircle,
  Info,
  LucideAngularModule,
  LucideIconData,
  XCircle,
} from 'lucide-angular';

export type BannerType = 'success' | 'error' | 'info' | 'warning';

@Component({
  selector: 'skk-banner',
  imports: [LucideAngularModule],
  template: `
    <div class="banner" [class]="type()">
      <i-lucide [img]="icon()" [size]="22"></i-lucide>

      <div class="content">
        <ng-content></ng-content>
      </div>
    </div>
  `,
  styleUrl: './banner.scss',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class Banner {
  readonly type = input<BannerType>('info');
  readonly customIcon = input<LucideIconData | null>(null);

  readonly icon = computed((): LucideIconData => {
    const customIcon = this.customIcon();
    if (customIcon) {
      return customIcon;
    }

    switch (this.type()) {
      case 'success':
        return CheckCircle;
      case 'error':
        return XCircle;
      case 'warning':
        return AlertTriangle;
      case 'info':
      default:
        return Info;
    }
  });
}
